import { useGetSoldServicesAppDataOnMount } from '@user/store/branches/hooks/useGetSoldServicesAppDataOnMount'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { Sidebar } from '../../BulkActionsSidebar'
import { BulkCloseWinOpportunityInput } from '../../typings/BulkCloseWin/BulkCloseWinOpportunityInput'
import { FormFields } from './FormFields'
import { useFormActions } from './hooks/useFormActions'
import { useGetBranchDetailOnMount } from './hooks/useGetBranchDetailOnMount'
import { useOnSubmit } from './hooks/useOnSubmit'
import { ValidationCallback } from './typings'

type Props = {
  submitHandler: (b: BulkCloseWinOpportunityInput) => Promise<void>
  validateRows: ValidationCallback
}

const initialValues = {}

export const BulkCloseWinForm: React.FC<Props> = (props) => {
  const { handleSubmit, ids } = useFormActions(props)

  const [branchId, setBranch] = useState('')

  const { oppBranchInfo, branchInfoStatus } = useGetBranchDetailOnMount(ids)
  const appDataState = useGetSoldServicesAppDataOnMount(branchId)

  const onSubmit = useOnSubmit(ids, appDataState.appData, handleSubmit)

  useEffect(() => {
    if (branchInfoStatus === 'success' && oppBranchInfo) {
      setBranch(oppBranchInfo[0].branchId)
    }
  }, [branchInfoStatus])

  return (
    <Sidebar
      title="Close / Win"
      onSubmit={onSubmit}
      initialValues={initialValues}
    >
      {branchInfoStatus === 'success' && (
        <FormFields
          readonly={oppBranchInfo.length > 1}
          appDataState={appDataState}
          {...props}
        />
      )}
    </Sidebar>
  )
}
BulkCloseWinForm.displayName = 'BulkCloseWinForm'
